import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { IStudent } from '../../../../core/models/user';
import { AuthImageUrlPipe } from "../../../../shared/pipes/auth-image-url.pipe";

@Component({
  selector: 'app-learner-avatar',
  standalone: true,
  imports: [CommonModule, AuthImageUrlPipe],
  templateUrl: './learner-avatar.component.html',
  styleUrl: './learner-avatar.component.scss'
})
export class LearnerAvatarComponent {
  learner = input.required<IStudent>();
  size = input<number>(29);
}
